import { motion } from "framer-motion"

const IconBack = ({ className, size = 32, fill = "currentColor", ...animations }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <motion.path
      {...animations}
      d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"
      fill={fill}
      stoke="none"
      fillRule="evenodd"
    />
  </svg>
)

export default IconBack
